// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Payment Analysis',
  subtitle: 'Payment statistics and analysis',
  totalRevenue: 'Total Revenue',
  totalExpense: 'Total Expense',
  netProfit: 'Net Profit',
  averagePayment: 'Average Payment',
  paymentCount: 'Payment Count',
  byMonth: 'Monthly',
  byYear: 'Yearly',
  byCompany: 'By Company',
  byType: 'By Type',
  noData: 'No analysis data',
  fetchError: 'Analysis data could not be retrieved',
  currency: 'Currency',
  analysisView: 'Analysis View',
  byCompanyAnalysis: 'Analysis by Company',
  byCustomer: 'By Customer',
  byCustomerAnalysis: 'Analysis by Customer',
  totalPurchase: 'Total Purchase',
  totalSale: 'Total Sale',
  totalProfit: 'Total Profit',
  totalPayments: 'Total Payments',
  purchase: 'Purchase',
  sale: 'Sale',
  profit: 'Profit',
  company: 'Company',
  customer: 'Customer',
  packageName: 'Package Name',
  packageType: 'Package Type',
  type: 'Type',
  frequency: 'Frequency',
  paymentDetails: 'Payment Details',
  details: 'Details',
  hide: 'Hide',
  noPayments: 'No payments found',
  noPaymentsDesc: 'No payment records yet.',
  unknownCompany: 'Unknown Company',
  unknownCustomer: 'Unknown Customer',
  unassignedCustomer: 'Unassigned',
  sheetName: 'Payment Analysis',
  exportSuccess: 'Data successfully exported'
};
